export default "__VITE_ASSET__CDyfBQBj__"